import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Text } from '@fluentui/react';
import { CardStepLayout } from '@bingads-webui-campaign-react/shared-step-layouts';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import classNames from 'classnames';

const stepCardStyles = {
  title: {
    root: {
      margin: '15px 0',
    },
  },
  description: {
    root: {
      marginTop: 10,
      maxWidth: 500,
      textAlign: 'center',
    },
  },
};

const getStyles = () => ({
  container: {
    '& .card-container': {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 795,
      minHeight: 635,
    },
    '& .step-footer': {
      justifyContent: 'center',
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  content: {
    flex: 1,
    flexBasis: 350,
  },
});

export const StepCardBaseContainer = (props) => {
  const {
    children,
    className,
    title,
    description,
    ...restProps
  } = props;

  const classes = useDefaultStyles(getStyles);

  const renderPageHeader = useCallback(() => (
    <React.Fragment>
      {
        title &&
        <Text
          variant="xxLarge"
          block
          styles={stepCardStyles.title}
          className="smart-page-step-page-title"
          as="h1"
        >
          {title}
        </Text>
      }
      {
        description &&
        <Text
          variant="medium"
          block
          styles={stepCardStyles.description}
          className="smart-page-step-page-description"
        >
          {description}
        </Text>
      }
    </React.Fragment>
  ), [title, description]);

  return (
    <CardStepLayout
      className={classNames('step-card-container', classes.container, className)}
      {...restProps}
    >
      <div className={classNames('step-card-header', classes.header)}>
        {renderPageHeader()}
      </div>
      <div className={classNames('step-card-content', classes.content)}>
        {children}
      </div>
    </CardStepLayout>
  );
};

StepCardBaseContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

StepCardBaseContainer.defaultProps = {
  className: '',
  title: '',
  description: '',
};
